import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import { authAPI } from '../api';

const DEMO_ACCOUNTS = [
  { user: 'James', flag: '🇺🇸', lang: 'English' },
  { user: 'Sakura', flag: '🇯🇵', lang: '日本語' },
  { user: 'Maria', flag: '🇪🇸', lang: 'Español' },
  { user: 'Sophie', flag: '🇫🇷', lang: 'Français' },
  { user: 'Minji', flag: '🇰🇷', lang: '한국어' },
  { user: 'Luca', flag: '🇮🇹', lang: 'Italiano' },
  { user: 'Olga', flag: '🇷🇺', lang: 'Русский' },
  { user: 'XiaoMing', flag: '🇨🇳', lang: '中文' },
];

export default function LoginPage() {
  const { t } = useI18n();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('demo123');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login({ username, password });
      login(res.data.user, res.data.token);
      navigate('/discover');
    } catch (err) {
      setError(err.response?.data?.error || t('loginFail'));
    } finally {
      setLoading(false);
    }
  };

  const quickLogin = async (u) => {
    setUsername(u);
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login({ username: u, password: 'demo123' });
      login(res.data.user, res.data.token);
      navigate('/discover');
    } catch (err) {
      setError(err.response?.data?.error || t('loginFail'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-center">
      <div className="auth-card">
        <h1 className="auth-title">Global Heart</h1>
        <p className="auth-subtitle">{t('appSlogan')}</p>
        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-error">{error}</div>}
          <div className="field">
            <label>{t('username')}</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)}
              placeholder={t('usernamePh')} required />
          </div>
          <div className="field">
            <label>{t('password')}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder={t('passwordPh')} required />
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? '🌍 ...' : '🚀 ' + t('loginBtn')}
          </button>
        </form>

        <div style={{ marginTop: 24 }}>
          <div style={{ fontSize: '0.82rem', color: 'var(--text-dim)', marginBottom: 10 }}>
            {t('loginSubtitle')} <span style={{ opacity: 0.5 }}>(demo123)</span>
          </div>
          <div className="lang-options" style={{ justifyContent: 'center' }}>
            {DEMO_ACCOUNTS.map(a => (
              <button key={a.user} type="button" className={`lang-btn ${username === a.user ? 'selected' : ''}`}
                onClick={() => quickLogin(a.user)}>
                {a.flag} {a.user}
              </button>
            ))}
          </div>
        </div>

        <p className="auth-footer" style={{ marginTop: 20 }}>
          {t('noAccount')} <Link to="/register">{t('createAccount')} →</Link>
        </p>
      </div>
    </div>
  );
}
